import { type QuestionnaireItem, type QuestionnaireResponseItem } from "fhir/r3"
import { Button } from "nhsuk-react-components"
import { useContext, type MouseEventHandler } from "react"
import { QuestionnaireContext } from "../../context/QuestionnaireContext"
import { Question } from "./Question"

interface Props {
  onPrevious?: MouseEventHandler
  question: QuestionnaireItem
  responses: QuestionnaireResponseItem[]
  onContinue: () => void
  setResponses: (responses: QuestionnaireResponseItem[]) => void
}

export type QuestionPanelError = "required"

export function QuestionPanel({ question, responses, setResponses, onContinue, onPrevious }: Props): JSX.Element {
  const questionnaireContext = useContext(QuestionnaireContext)
  if (!questionnaireContext) {
    throw new Error("QuestionnaireSummary must be used within a QuestionnaireProvider")
  }
  const { validateResponses } = questionnaireContext

  const saveResponses = (response?: QuestionnaireResponseItem): void => {
    if (response != null) {
      if (responses.some((oldAnswer: QuestionnaireResponseItem) => oldAnswer.linkId === response.linkId)) {
        const updatedResponses = responses.map((oldResponse) => {
          if (response.linkId === oldResponse.linkId) {
            return response
          } else {
            return oldResponse
          }
        })
        setResponses(updatedResponses)
      } else {
        setResponses([...responses, response])
      }
    }
  }

  return (
    <div aria-live="polite">
      <Question question={question} saveResponses={saveResponses} topLevel />
      <Button
        onClick={() => {
          const isValid = validateResponses()
          if (!isValid) {
            return
          }
          onContinue()
        }}
      >
        Continue
      </Button>
      {onPrevious != null && (
        <p className="text-link" role="button" onClick={onPrevious}>
          Previous
        </p>
      )}
    </div>
  )
}
